import {
  core_v1_Rule,
  coreV1CreateRuleMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { setClientOfOrigin } from '@/utils/setClientOfOrigin';

export const useCreateRule = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: (data: core_v1_Rule) => {
      const dataWithClientOrigin = setClientOfOrigin(data);
      return coreV1CreateRuleMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: dataWithClientOrigin, path: { workspace } });
    },
  });
};
